@for (toast of toastService.toastInfos; track toast) {
  <ngb-toast
    [header]="toast.header" [autohide]="true" [delay]="toast.delay || 3000"
    (hidden)="toastService.remove(toast)"
    [class]="toast.style"
  >{{ toast.body }}</ngb-toast>
}
